import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import Button from '../../elements-buttons/Button';
import { isFunction } from 'lodash';
import CreateItemFormContainer from '../../app-main/components/reduxForms/forms/CreateItemForm/CreateItemFormContainer';
import { fetchInventory } from '../../app-main/actions/inventory';
import { FormattedMessage } from 'react-intl';

export default class EditAddOnModal extends Component {
  constructor (props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount () {
    const { scrollToTop, showModal } = this.props;

    if (isFunction(scrollToTop) && showModal) {
      scrollToTop();
    }
  }

  closeModal () {
    const {
      spaceId,
      accessToken,
      toggleModal,
      dispatch,
      fromManageAddons
    } = this.props;

    if (fromManageAddons) {
      dispatch(fetchInventory(spaceId, accessToken));
    }

    toggleModal('');
  }

  render () {
    const {
      currency,
      isFetchingitem,
      createItem,
      isSubmitting,
      toggleModal,
      iosWebView,
      whichModal,
      spaceId,
      fromManageAddons
    } = this.props;

    return (
      <div>
        {
          iosWebView && ('editAddOnModal' === whichModal) ?
            <div className="edit-item-form-ios">
              <div>
                <span className="pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
                <h3><FormattedMessage /><FormattedMessage id="hosting.edit_add_on_modal.edit_item_heading" defaultMessage="Edit Item"/></h3>
              </div>

              <CreateItemFormContainer
                currency={currency}
                isEditAddOnModal
                isLoading={isFetchingitem}
                toggleModal={toggleModal}
                spaceId={spaceId}
                iosWebView
              />

              <CTAButton
                buttonText="Save"
                classNameString="btn btn-primary form"
                onClickAction={createItem}
                isDisabled={ false }
                spinning={isSubmitting}
                attributes={{ 'data-testing-id': 'create-add-on-button' }}
              />
            </div>
            :
            <BootstrapModal
              {...this.props}
              onClose={this.closeModal}
              modalSize="sm-size"
              modalClass="edit-add-on-modal"
              header={ <h3><FormattedMessage id="hosting.edit_add_on_modal.edit_item_heading" defaultMessage="Edit Item"/></h3> }
              body={
                <CreateItemFormContainer
                  currency={currency}
                  isEditAddOnModal
                  isLoading={isFetchingitem}
                  toggleModal={toggleModal}
                  spaceId={spaceId}
                  fromManageAddons={fromManageAddons}
                />
              }
              footer={
                <div className="flex space-between">
                  <Button
                    category="danger"
                    onClick={() => toggleModal('deleteAddOnModal')}
                    attributes={{ 'data-testing-id': 'edit-add-on-button' }}
                    isLoading={isSubmitting}
                  >
                    <FormattedMessage id="hosting.edit_add_on_modal.edit_item_button_text_delete" defaultMessage="Delete"/>
                  </Button>
                  <Button
                    category="primary"
                    onClick={createItem}
                    attributes={{ 'data-testing-id': 'edit-add-on-button' }}
                    isLoading={isSubmitting}
                  >
                    <FormattedMessage id="hosting.edit_add_on_modal.edit_item_button_text_save_changes" defaultMessage="Save Changes"/>
                  </Button>
                </div>
              }
            />
        }
      </div>
    );
  }
}

EditAddOnModal.propTypes = {
  errorMsg: PropTypes.string,
  currency: PropTypes.string,
  createItem: PropTypes.func,
  isLoading: PropTypes.bool,
  isFetchingitem: PropTypes.bool,
  scrollToTop: PropTypes.func,
  toggleModal: PropTypes.func,
  isSubmitting: PropTypes.bool,
  iosWebView: PropTypes.bool,
  whichModal: PropTypes.bool,
  spaceId: PropTypes.string,
  dispatch: PropTypes.func,
  fromManageAddons: PropTypes.bool,
  showModal: PropTypes.bools,
  accessToken: PropTypes.string
};
